
export default class StateAvailableHoursModel{
    constructor(data) {
      if(!data)
        data = {}
      this.state = data.state || ""
      this.hours = data.hours || 0
    }
  }